__turbopack_context__.v({
  "benzingaBriefs": "YED33W_benzingaBriefs",
  "benzingaBriefsHeader": "YED33W_benzingaBriefsHeader",
  "briefDate": "YED33W_briefDate",
  "briefListItem": "YED33W_briefListItem",
  "briefListItemTextContent": "YED33W_briefListItemTextContent",
  "briefTitle": "YED33W_briefTitle",
  "readMore": "YED33W_readMore",
  "tickerList": "YED33W_tickerList",
});
